import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { ApplicationListEditRequest } from 'src/types/rest/tenant';

export const useEditApplicationList = (applicationListId: string) => {
  const queryClient = useQueryClient();

  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: ApplicationListEditRequest) =>
      apiRequest<void>({
        data: variables,
        method: 'PATCH',
        url: `${apiHost}/application-lists/${applicationListId}`,
      }),
    onSuccess: (variables) => {
      queryClient.setQueryData(
        ['applicationList', applicationListId],
        variables,
      );
    },
  });
};
